import React from 'react';
import { PRICING } from '../pricing';
import QuizIcon from '@mui/icons-material/Quiz';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

export const aiInterviewPrep = {
    title: "Interview Prep",
    subtitle: "Elite Career Track",
    badge: "MOST ENROLLED",
    icon: <QuizIcon sx={{ fontSize: 40, color: '#14b8a6' }} />,
    description: "Master DSA, System Design & AI with interactive visualizations.",
    marketing: {
      image: '/flowstate/ai_prep_robot.png',
      labels: ['Self-Paced', 'Interactive Visualization'],
      cta: 'Start Learning'
    },
    features: [
      "Data Structures & Algorithms",
      "AI Fundamentals",
      "AI Engineering"
    ],
    price: PRICING.aiInterviewPrep.price,
    mrp: PRICING.aiInterviewPrep.mrp,
    topics: [
      {
        id: "twoPointers",
        title: "Two Pointer Mastery",
        desc: "Utilize two pointers to iterate through an array or list from different ends or with different speeds.",
        badge: "Array/String",
        fileUrl: "/documents/dsa/two_pointer.md",
        group: "Data Structures & Algorithms",
        problems: [
          { id: "tp_1", title: "Linked List Cycle", badge: "Easy", fileUrl: "/documents/dsa/tp_ll_cycle.md" },
          { id: "tp_2", title: "Two Sum II", badge: "Medium", fileUrl: "/documents/dsa/tp_two_sum.md" }
        ]
      },
      {
        id: "slidingWindow",
        title: "Sliding Window Patterns",
        desc: "Use two pointers or a deque to maintain a window of elements that satisfies a condition.",
        badge: "Array/String",
        fileUrl: "/documents/dsa/sliding_window.md",
        group: "Data Structures & Algorithms",
        problems: [
          { id: "sw_1", title: "Longest Substring Without Repeating", badge: "Medium", fileUrl: "/documents/dsa/sw_longest_sub.md" },
          { id: "sw_2", title: "Minimum Window Substring", badge: "Hard", fileUrl: "/documents/dsa/sw_min_window.md" }
        ]
      },
      {
        id: "dfs",
        title: "Binary Tree DFS",
        desc: "Use recursion or an explicit stack to traverse the tree pre-order, in-order, or post-order.",
        badge: "Tree",
        fileUrl: "/documents/dsa/dfs.md",
        group: "Data Structures & Algorithms",
        problems: [
          { id: "dfs_1", title: "Binary Tree Inorder Traversal", badge: "Easy", fileUrl: "/documents/tree_inorder.md" },
          { id: "dfs_4", title: "Binary Tree Maximum Path Sum", badge: "Hard", fileUrl: "/documents/dsa/dfs_max_path_sum.md" }
        ]
      },
      {
        id: "ai_intro",
        title: "Intro to AI Fundamentals",
        desc: "History, types of AI, and future landscape.",
        badge: "Core",
        fileUrl: "/documents/ai/ai_intro.md",
        icon: <TipsAndUpdatesIcon />,
        group: "AI Fundamentals",
        problems: []
      },
      {
        id: "llm_apps",
        title: "Building LLM Applications",
        desc: "Prompt Engineering, RAG, and Vector DBs.",
        badge: "Advanced",
        fileUrl: "/documents/ai/ai_llm_apps.md",
        icon: <RocketLaunchIcon />,
        group: "AI Engineering",
        problems: []
      },
      {
        id: "ai_interview_quizzes",
        title: "AI Interview Practice Quizzes",
        desc: "Consolidated assessment for AI interview preparation.",
        badge: "Quiz",
        icon: <QuizIcon />,
        group: "Final Assessment",
        problems: [
          { id: "quiz_ai_intro", title: "Intro to AI Quiz", badge: "Quiz", fileUrl: "/documents/quizzes/quiz_ai_intro.md" },
          { id: "quiz_llm_apps", title: "Building LLM Apps Quiz", badge: "Quiz", fileUrl: "/documents/quizzes/quiz_llm_apps.md" }
        ]
      }
    ]
  };
